export const PREFERRED_NOTARIES = {
  SEARCH_DISTANCE_OPTIONS_FOR_SELECT: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
}
